import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQuery";

export const documentValidationApi = createApi({
  reducerPath: "documentValidationApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["DocumentValidation"],
  endpoints: (builder) => ({
    // Get all document validations
    getDocumentValidations: builder.query({
      query: ({ company_profile_id, registration_id, status } = {}) => ({
        url: "/document-validations",
        params: {
          ...(company_profile_id && { company_profile_id }),
          ...(registration_id && { registration_id }),
          ...(status && { status }),
        },
      }),
      transformResponse: (response) => response.data || response,
      providesTags: ["DocumentValidation"],
    }),

    // Get a single document validation by ID
    getDocumentValidationById: builder.query({
      query: (id) => `/document-validations/${id}`,
      transformResponse: (response) => response.data || response,
      providesTags: (result, error, id) => [{ type: "DocumentValidation", id }],
    }),

    // Update a single document validation
    updateDocumentValidation: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/document-validations/${id}`,
        method: "PUT",
        body: data,
      }),
      transformResponse: (response) => response.data || response,
      invalidatesTags: ["DocumentValidation"],
    }),

    // Bulk update document validations
    bulkUpdateDocumentValidations: builder.mutation({
      query: (updates) => ({
        url: "/document-validations/bulk-update",
        method: "POST",
        body: { updates },
      }),
      transformResponse: (response) => response.data || response,
      invalidatesTags: ["DocumentValidation"],
    }),

    // Delete a document validation
    deleteDocumentValidation: builder.mutation({
      query: (id) => ({
        url: `/document-validations/${id}`,
        method: "DELETE",
      }),
      transformResponse: (response) => response.data || response,
      invalidatesTags: ["DocumentValidation"],
    }),
  }),
});

export const {
  useGetDocumentValidationsQuery,
  useGetDocumentValidationByIdQuery,
  useUpdateDocumentValidationMutation,
  useBulkUpdateDocumentValidationsMutation,
  useDeleteDocumentValidationMutation,
} = documentValidationApi;
